// extracted by mini-css-extract-plugin
export default {"container":"NavLinksAdmin_container__1UxWA","containerWhite":"NavLinksAdmin_containerWhite__qonTu","active":"NavLinksAdmin_active__5rAvc"};